<div
  class="slider-component__item"
  tabindex="0"
  [attr.aria-label]="title + (item?.icon?.label !== '' ? (', ' + ('general.formatType' | translate) + ' ' + (item?.icon?.label | translate)) : '')"
  [class.selected-item]="active"
  (mouseover)="setStateHover(true)"
  (mouseout)="setStateHover(false)"
  (click)="onClicked(item)"
>
  <opac-record-cover [coverUrl]="item.covers[0]" [icon]="item.icon" [isList]="item.concatenatedCovers"></opac-record-cover>
  <div class="metadata">
    <span aria-hidden="true" class="title" [ellipsis]="ellipsisTitle()">
      {{ title }}
    </span>
    <span *ngIf="showAuthorViewCarousel()" aria-hidden="true" class="author" [ellipsis]="1">
      {{ item.author }}
    </span>
  </div>
</div>
